module.exports = __webpack_public_path__ + "assets/img/pin.7f755090.webp";